import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowUp } from "react-icons/ai";

export const UpgradeButton = () => {
    const navigate = useNavigate();

    return (
        <Button
            variant="gradient"
            gradient={{ from: 'blue', to: 'cyan', deg: 90 }}
            leftSection={<AiOutlineArrowUp size={'1.2em'}/>}
            onClick={() => navigate('/application-products')}
        >
            Upgrade
        </Button>
    );
};